var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isApplePaySupported)?_c('div',{attrs:{"id":"nspay-apple-pay"},on:{"click":_vm.processApplePayment}},[_c('div',{attrs:{"id":"apple-pay-logo"}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }